import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useList } from 'react-firebase-hooks/database';
import { Redirect, useHistory } from "react-router";
import "./Dashboard.css";
import { auth, db, logout } from "./firebase";

import moment from "moment-timezone";

import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FindInPageIcon from '@mui/icons-material/FindInPage';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { Form, Field } from 'react-final-form';


import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import { Icon } from "@material-ui/core";

import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';

import BlockIcon from '@mui/icons-material/Block';

import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';

import UserInfo from './UserInfo';
import Client from './Client';
import DeviceStatus from "./DeviceStatus";

//import useWindowScroll from "@react-hook/window-scroll";

import { useSpring, animated } from 'react-spring'


import Styles from './Styles';

import {styled} from "@mui/system";


function Clients(props) {
  //const [user, loading_user, error] = useAuthState(auth);
  const uid =   sessionStorage.getItem("uid");

  const history = useHistory();

  const [clients, setClients] = useState();
  const [filteredClients, setFilteredClients] = useState();
  const [deviceNumber, setDeviceNumber] = useState(0);
  const [selectedDevice, setSelectedDevice] = useState();
  const [selectedDeviceName, setSelectedDeviceName] = useState();

  const [openAdd, setOpenAdd] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(0)
  const [totalResults, setTotalResults] = useState(0);

  const [clientName, setClientName] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  const r = '/clients/';

  const [clients_snapshot, loading_clients, error_db] = useList(db.ref(r));

  /*
  const [flip, set] = useState(false)
  const props = useSpring({
    to: { opacity: 1 },
    from: { opacity: 0 },
    reset: true,
    reverse: flip,
    delay: 200,
    onRest: () => set(!flip),
  }) */

  const LinkButton = styled(Button)({
    textTransform: 'none',
  });

  useEffect(() => {
    if(clients_snapshot && !loading_clients)
    {
      var dv = [];
      clients_snapshot.map(client => {
        //console.log(client.key + " :: " + client.val().info);
        dv.push({
          id: client.key,
          info: client.val()
        })
      })
      setClients(dv);
      setIsAdmin(sessionStorage.getItem("admin")=="true");
    }
  }, [clients_snapshot, loading_clients]);


  if (!isAdmin)
  {
    return (<div style={{alignItems: "center", display: 'flex', justifyContent: 'center', height: "100vh", width: "100vw" }}>
            <Box sx={{ display: 'flex' }}>
              <Typography variant="caption" style={{textAlign: "center"}} component="div" color="text.secondary">
                <IconButton onClick={() => history.goBack()}>
                    <BlockIcon />
                </IconButton>
                Authorized user only...
              </Typography>
            </Box>
            </div>);
  }

  if (loading_clients)
  {
    return (<div style={{alignItems: "center", display: 'flex', justifyContent: 'center', height: "100vh", width: "100vw" }}>
            <Box sx={{ display: 'flex' }}>
              <Typography variant="caption" style={{textAlign: "center"}} component="div" color="text.secondary">
                <CircularProgress /><br />
                Loading clients list...
              </Typography>
            </Box>
            </div>);
  }


  const onSubmit = async values => {
   
}

const showClient = (uid) => {
    console.log(uid)
    history.push(
        { pathname: '/client',
          state: {
              uid: uid,
          }
        });
}

const updateClient = (clientId) => {
    history.push(
        { pathname: '/update_client',
          state: {
            uid: uid,
          }
        });
}

const deleteDevice = () => {
  //console.log("Post start datetime:: " + moment(startDateTime).format("YYYY-MM-DD HH:mm:ss"));
  //console.log("Post end datetime:: " + moment(endDateTime).format("YYYY-MM-DD HH:mm:ss"));
}

const handleDelete = (id, name) => {
    setSelectedDevice(id);
    setSelectedDeviceName(name);
    setOpenDelete(true);
}

const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };

const handleCloseAdd = () => {
    setOpenAdd(false);
  };

const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeClientName = (event) => {
    //alert(event.target.value)
    if(event.target.value.length > 0)
    {
      setClientName(event.target.value)
      setFilteredClients(clients.filter(client => client.info.username.toLowerCase().includes(event.target.value) ||
        (client.info.info.hasOwnProperty('title') && client.info.info.title.toLowerCase().includes(event.target.value)) || 
        (client.info.info.hasOwnProperty('displayName') && client.info.info.displayName.toLowerCase().includes(event.target.value)) 
      ))
    }
    else
    {
      setClientName("");
      setFilteredClients(null);
    }
  };

const handleClearClientName = (event) => {
    //alert(event.target.value)
    setClientName("");
    setFilteredClients(null);
  };


  return (
    <div className="container">  
            <Container maxWidth="xl" >
                <Grid container spacing={2} sx={{pt: 12, pl:2, pr:2, pb:2}}>
                    <Grid item xs={12}>
                        <Card style={{height: '100%'}}>
                            <CardContent>
                                <Typography variant="h6" component="div">
                                Clients [Admin mode]
                                </Typography>
                                <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                All {clients && clients.length} clients listed from database.
                                </Typography>
                                <Typography variant="body2">
                                All clients in the system, both activated and not-yet-activated, is listing here. Each client can be viewed, edited, or deleted upon admin or power user level of authorization only.
                                </Typography>
                                <Grid container spacing={2} sx={{p: 2}}>
                                  <Grid item xs={12}>
                                      
                                  </Grid>
                              </Grid>
                            </CardContent>
                            {/*<CardActions>
                                <Button onClick={handleClickOpenAdd}>Add New Device</Button>
                                        </CardActions>*/}
                        </Card>
                        
                    </Grid>
                                <Grid item xs={12}>
                                    <Paper elevation={2}>
                                        <TableContainer component={Paper}>
                                            <Table sx={{ minWidth: 600 }} aria-label="simple table">
                                                <TableHead>
                                                <TableRow>
                                                    <TableCell align="center">UID</TableCell>
                                                    <TableCell align="center">Email</TableCell>
                                                    <TableCell align="center">Username</TableCell>
                                                    <TableCell align="center">Store Name</TableCell>
                                                    <TableCell align="center">View</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                <TableCell align="center"></TableCell>
                                                <TableCell align="center"></TableCell>
                                                
                                                <TableCell align="left" colSpan={3}>
                                                    <FormControl sx={{ m: 1, width: '80ch' }} variant="standard">
                                                        <InputLabel htmlFor="outlined-adornment-password">Search Email | Username | Store Name ({clientName.length==0 ? "all ": "found "} {filteredClients ? filteredClients.length : clients.length})</InputLabel>
                                                        <Input
                                                            id="outlined-adornment-password"
                                                            type='text'
                                                            value={clientName}
                                                            onChange={handleChangeClientName}
                                                            startAdornment={
                                                            <InputAdornment position="start">
                                                                <IconButton
                                                                aria-label="search site name"
                                                                //onClick={handleChangeDeviceName}
                                                                //onMouseDown={handleChangeDeviceName}
                                                                edge="end"
                                                                >
                                                                <SearchIcon />
                                                                </IconButton>
                                                            </InputAdornment>
                                                            }
                                                            endAdornment={
                                                                <InputAdornment position="end">
                                                                    { clientName ?
                                                                    (<IconButton
                                                                    aria-label="search site name"
                                                                    onClick={handleClearClientName}
                                                                    //onMouseDown={handleChangeDeviceName}
                                                                    edge="end"
                                                                    >
                                                                    <ClearIcon />
                                                                    </IconButton>) : (<div/>)
                                                                    }
                                                                </InputAdornment>
                                                            }
                                                        />
                                                        </FormControl> 
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                {filteredClients ? (
                                                    filteredClients.map(function(client){
                                                        return <TableRow
                                                        key={client.id}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                        > 
                                                            <TableCell align="left" scope="row">{client.id}</TableCell>
                                                            <TableCell align="left" scope="row">{client.info.username}</TableCell>
                                                            <TableCell align="left" scope="row">{client.info.info.displayName}</TableCell>
                                                            <TableCell align="left"><LinkButton variant='text' onClick={e => showClient(client.id)}>{client.info.info.title}</LinkButton></TableCell>
                                                            <TableCell align="center">
                                                              <IconButton onClick={e => showClient(client.id)}>
                                                                <FindInPageIcon color="info" />
                                                              </IconButton>
                                                            </TableCell>
                                                            {/* 
                                                            <TableCell align="center">
                                                                <Button variant="contained" color="error" onClick={e => handleDelete(site.id, site.name)} >Delete</Button>
                                                            </TableCell>
                                                            */}
                                                        </TableRow>
                                                    })
                                                ) : (
                                                    clients.map(function(client){
                                                        return <TableRow
                                                        key={client.id}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                        >
                                                            <TableCell align="left" scope="row">{client.id}</TableCell>
                                                            <TableCell align="left" scope="row">{client.info.username}</TableCell>
                                                            <TableCell align="left" scope="row">{client.info.info.displayName}</TableCell>
                                                            <TableCell align="left"><LinkButton variant='text' onClick={e => showClient(client.id)}>{client.info.info.title}</LinkButton></TableCell>
                                                            <TableCell align="center">
                                                              <IconButton onClick={e => showClient(client.id)}>
                                                                <FindInPageIcon color="info" />
                                                              </IconButton>
                                                            </TableCell>
                                                            {/* 
                                                            <TableCell align="center">
                                                                <Button variant="contained" color="error" onClick={e => handleDelete(site.id, site.name)} >Delete</Button>
                                                            </TableCell>
                                                            */}
                                                        </TableRow>
                                                    })
                                                )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        {!clientName ? 
                                        <TablePagination
                                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                            component="div"
                                            count={totalResults}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                            /> : <div/>}
                                    </Paper>
                                    </Grid>
                </Grid>
                
                <Dialog
                    open={openDelete}
                    onClose={() => handleCloseDelete}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    >
                    <DialogTitle id="alert-dialog-title">
                        {"Delete device??"}
                        </DialogTitle>
                        <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Delete device #{selectedDevice} with title "{selectedDeviceName}" from database? This cannot be undone.
                        </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={handleCloseDelete}>Cancel</Button>
                        <Button color="error" onClick={deleteDevice} autoFocus>
                            Delete
                        </Button>
                        </DialogActions>
                    </Dialog>
                    <Grid container spacing={2} sx={{p: 4}}>
                    <Grid item xs={12}></Grid> 
                </Grid>
            </Container>
    </div>
  );
}

export default Clients;
